export const DEFAULT_PERSIST_SLICE_LIMIT = 10;
export const DEFAULT_PERSIST_SLICE_ID = 'id';
